// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9048) return "9048_7986b3d08a03a5dfc5f3.js";
	// return url for filenames based on template
	return undefined;
};